import { Container, Row, Col } from "reactstrap";

// Privacy/deletion requests go to the privacy@dejachart.com Google Workspace group
// (forwards to the team).
const EFFECTIVE_DATE = "June 18, 2026";

export default function Privacy() {
  return (
    <div style={{ paddingTop: "3rem", paddingBottom: "5rem" }}>
      <Container>
        <Row className="justify-content-center">
          <Col lg="8" md="10">
            <h1 className="page-title">Privacy Policy</h1>
            <p style={{ color: "var(--text-muted)", marginBottom: "2.5rem" }}>
              Effective date: {EFFECTIVE_DATE}
            </p>

            <p>
              DejaChart ("we," "us," or "our") is committed to protecting your privacy. This
              Privacy Policy explains how we collect, use, and share information when you use our
              website and services (the "Service").
            </p>

            <h4>1. Information We Collect</h4>
            <p><strong>Information you provide:</strong></p>
            <ul>
              <li>Account registration details (name, email address, password)</li>
              <li>Payment information (processed by Stripe — we do not store card numbers)</li>
              <li>Communications you send us (e.g. support emails)</li>
            </ul>
            <p><strong>Information collected automatically:</strong></p>
            <ul>
              <li>Usage data (pages visited, features used, search queries)</li>
              <li>Device and browser information</li>
              <li>IP address and approximate location</li>
              <li>Cookies and similar tracking technologies</li>
            </ul>

            <h4>2. How We Use Your Information</h4>
            <p>We use the information we collect to:</p>
            <ul>
              <li>Provide, operate, and improve the Service</li>
              <li>Process payments and manage subscriptions</li>
              <li>Send transactional emails (receipts, password resets, subscription notices)</li>
              <li>Send product updates and market insights (you may unsubscribe at any time)</li>
              <li>Detect and prevent fraud or abuse</li>
              <li>Comply with legal obligations</li>
            </ul>

            <h4>3. How We Share Your Information</h4>
            <p>
              We do not sell your personal information. We share information only with:
            </p>
            <ul>
              <li>
                <strong>Service providers</strong> who help us operate the Service — including
                Amazon Web Services (authentication and hosting), Stripe (payment processing),
                PostHog (product analytics), and our email delivery provider. These providers
                process data on our behalf and are contractually bound to protect it.
              </li>
              <li>
                <strong>Legal authorities</strong> if required by law or to protect our rights.
              </li>
              <li>
                <strong>Acquirers</strong> in connection with a merger, acquisition, or sale of
                assets, with notice provided to you.
              </li>
            </ul>

            <h4>4. Cookies &amp; Analytics</h4>
            <p>
              We use cookies and similar technologies to maintain your session and remember your
              preferences (such as dark/light mode). We also use PostHog, a product-analytics
              service, to understand how the Service is used (for example, which pages and features
              are visited) so we can improve it; PostHog may set identifiers and, for signed-in
              users, associate usage with your account. You can disable cookies in your browser
              settings, but some features may not work properly.
            </p>

            <h4>5. International Data Transfers</h4>
            <p>
              We and our service providers are based in the United States, and your information is
              processed and stored there. If you access the Service from outside the United States,
              you consent to the transfer and processing of your information in the United States,
              which may have different data-protection laws than your jurisdiction.
            </p>

            <h4>6. Data Retention</h4>
            <p>
              We retain your account data for as long as your account is active or as needed to
              provide the Service. You may request deletion of your account by emailing us at{" "}
              <a href="mailto:privacy@dejachart.com">privacy@dejachart.com</a>. We will delete
              or anonymize your data within 30 days, unless retention is required by law.
            </p>

            <h4>7. Security</h4>
            <p>
              We implement industry-standard security measures including encrypted connections
              (TLS), hashed passwords, and access controls. No system is completely secure;
              we cannot guarantee absolute security of your data.
            </p>

            <h4>8. Children&apos;s Privacy</h4>
            <p>
              The Service is not directed to children under 18. We do not knowingly collect
              personal information from minors. If you believe a minor has provided us data,
              please contact us and we will delete it.
            </p>

            <h4>9. Your Rights</h4>
            <p>
              Depending on your location, you may have rights to access, correct, or delete your
              personal information, or to object to or restrict certain processing. To exercise
              these rights, contact us at{" "}
              <a href="mailto:privacy@dejachart.com">privacy@dejachart.com</a>.
            </p>

            <h4>10. Third-Party Links</h4>
            <p>
              The Service may contain links to third-party websites. We are not responsible for
              the privacy practices of those sites and encourage you to review their policies.
            </p>

            <h4>11. Changes to This Policy</h4>
            <p>
              We may update this Privacy Policy from time to time. We will notify you of material
              changes by posting the new policy on this page with an updated effective date.
            </p>

            <h4>12. Contact</h4>
            <p>
              Questions about this policy? Contact us at{" "}
              <a href="mailto:privacy@dejachart.com">privacy@dejachart.com</a>.
            </p>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
